import { Component } from '@angular/core';

@Component({
  selector: 'app-save',
  imports: [],
  template: `<svg
  width="24"
  height="24"
  viewBox="0 0 19 19"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M13.0298 16.3196H5.36051C4.80116 16.3196 4.26471 16.0974 3.86919 15.7019C3.47367 15.3064 3.25146 14.7699 3.25146 14.2106V5.00748C3.25146 4.44813 3.47367 3.91168 3.86919 3.51616C4.26471 3.12064 4.80116 2.89844 5.36051 2.89844H11.1124C11.2649 2.89857 11.4112 2.95926 11.5189 3.06716L14.9701 6.54133C15.078 6.6491 15.1387 6.7953 15.1388 6.9478V14.2106C15.1388 14.7699 14.9166 15.3064 14.5211 15.7019C14.1256 16.0974 13.5891 16.3196 13.0298 16.3196ZM5.36051 4.04882C5.10626 4.04882 4.86242 4.14983 4.68264 4.32961C4.50285 4.50939 4.40185 4.75323 4.40185 5.00748V14.2106C4.40185 14.4648 4.50285 14.7087 4.68264 14.8885C4.86242 15.0682 5.10626 15.1692 5.36051 15.1692H13.0298C13.284 15.1692 13.5278 15.0682 13.7076 14.8885C13.8874 14.7087 13.9884 14.4648 13.9884 14.2106V7.16254L10.8747 4.04882H5.36051Z"
    fill="white"
  />
  <path
    d="M12.838 15.7445H11.6876V10.9512H6.70263V15.7445H5.55225V10.7594C5.55225 10.5052 5.65325 10.2613 5.83303 10.0816C6.01281 9.90178 6.25665 9.80078 6.5109 9.80078H11.8794C12.1336 9.80078 12.3775 9.90178 12.5573 10.0816C12.737 10.2613 12.838 10.5052 12.838 10.7594V15.7445Z"
    fill="white"
  />
  <path
    d="M9.55562 7.11653H6.53394C6.40402 7.11552 6.27557 7.08894 6.15592 7.03829C6.03627 6.98764 5.92777 6.91392 5.83661 6.82134C5.74546 6.72876 5.67343 6.61913 5.62464 6.49871C5.57585 6.3783 5.55126 6.24945 5.55228 6.11952V3.47363H6.70266V5.96614H9.3869V3.47363H10.5373V6.11952C10.5383 6.24945 10.5137 6.3783 10.4649 6.49871C10.4161 6.61913 10.3441 6.72876 10.253 6.82134C10.1618 6.91392 10.0533 6.98764 9.93365 7.03829C9.814 7.08894 9.68555 7.11552 9.55562 7.11653Z"
    fill="white"
  />
</svg>
`
})
export class SaveComponent {

}
